var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScan = function SvgScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 .5h4a1 1 0 0 1 0 2H5v2a1 1 0 0 1-2 0v-4zM1 10a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1zM5 15.5a1 1 0 0 0-2 0v4h4a1 1 0 0 0 0-2H5v-2zM12 1.5a1 1 0 0 1 1-1h4v4a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1-1-1zM17 15.5a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h4v-4z"
  })));
};
export default SvgScan;